import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useState,
} from 'react'

const OverlayVisibilityContext = createContext(false)
const OverlayToggleContext = createContext<{
  close: () => void
  show: () => void
  toggle: (val: boolean) => void
}>({ close: () => undefined, show: () => undefined, toggle: () => undefined })

export const useOverlayVisibilityContext = () =>
  useContext(OverlayVisibilityContext)
export const useOverlayActionsContext = () => useContext(OverlayToggleContext)

export const SettingsOverlayContextProvider = ({
  children,
}: PropsWithChildren) => {
  const [isOverlayVisible, setOverlayVisible] = useState(false)

  return (
    <OverlayVisibilityContext.Provider value={isOverlayVisible}>
      <OverlayToggleContext.Provider
        value={{
          close: () => setOverlayVisible(false),
          show: () => setOverlayVisible(true),
          toggle: val => setOverlayVisible(val),
        }}
      >
        {children}
      </OverlayToggleContext.Provider>
    </OverlayVisibilityContext.Provider>
  )
}
